<template>
  <div>
    <div
      v-if="envTitle"
      class="layout__env-title"
    >
      ENVIRONMENT - {{ envTitle }}
    </div>
    <transition
      name="scale"
      mode="out-in"
    >
      <div
        v-if="isAuthenticated"
        class="flex flex-col h-screen w-screen"
      >
        <!-- This hidden element is required for Infra checks running against prod. DO NOT REMOVE -->
        <div
          id="infra-check-element"
          class="hidden"
        />
        <the-header />
        <div
          class="flex flex-1 min-h-0"
        >
          <side-nav />
          <div
            id="main-scroll-container"
            class="overflow-auto flex-grow flex flex-col"
          >
            <slot />
            <main-footer />
          </div>
          <modal-error-controller />
          <modal-new-quote
            v-if="showNewQuoteModal"
            ref="newQuoteModal"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalErrorController from '~/components/modal/modal-error-controller'

export default {
  name: 'Default',
  components: {
    ModalErrorController,
  },
  provide() {
    return {
      newQuoteModal: {
        open: this.openNewQuoteModal,
        close: this.closeNewQuoteModal,
      },
    }
  },
  // The New Quote Modal component exposes a value called `awaitingNavigation`.
  // `awaitingNavigation` will be `true` in the modal is awaiting the quote create request or the navigation to the quote flow.
  // This allows the `onBeforeRouteUpdate` route guard to distinguish if a navigation is caused by the New Quote Modal or not.
  // If a navigation is caused by the New Quote Modal then the `onBeforeRouteUpdate` route guard should not close the modal.
  // This is because the modal will emit a `close-new-quote-modal` event to close itself after quote creation and navigation are complete.
  beforeRouteUpdate() {
    if (this.$refs.newQuoteModal?.awaitingNavigation) {
      return
    }
    this.showNewQuoteModal = false
  },
  data() {
    return {
      showNewQuoteModal: false,
    }
  },
  computed: {
    envTitle() {
      switch (this.$config.public.vercelENV) {
        case 'development':
          return 'DEVELOPMENT'
        case 'preview':
          return 'STAGING'
        default:
          return null
      }
    },
    ...mapState({
      isAuthenticated: state => state.self.isAuthenticated,
    }),
  },
  watch: {
    $route: {
      handler() {
        this.$segment.sendPageEvent()
      },
      immediate: false,
    },
  },
  methods: {
    openNewQuoteModal() { this.showNewQuoteModal = true },
    closeNewQuoteModal() { this.showNewQuoteModal = false },
  },
}
</script>

<style scoped>
.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s ease;
}

.scale-enter,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.99);
}

.layout__env-title {
  @apply bg-orange text-white font-bold text-xs fixed left-0 right-0 mx-auto max-w-max px-2 py-1 border-white border-2 border-t-0 rounded-b-md shadow-md z-[120];
}
</style>
